import '../views/administration/accountGroups/overview.html';
import '../views/administration/accountGroups/accountGroup.html';
import '../views/administration/accountGroups/detail.html';

import { groups } from '../services/arsweb/RoutingPaths';

export const ADDROUTE = 'app.addGroup';
export const ADDTITLE = 'ADD_ACCOUNT_GROUP';
export const LISTROUTE = 'app.accountGroups';
export const LISTTITLE = 'ACCOUNT_GROUPS';

export const EDITROUTE = 'app.editGroup';
export const EDITTITLE = 'EDIT_ACCOUNT_GROUP';

export const DELETEROUTE = 'administration.deleteGroup';
export const DELETETITLE = 'DELETE_ACCOUNT_GROUP';
export const DETAIL_GROUPROUTE = 'app.viewGroup';
export const DETAIL_TITLE = 'VIEW_ACCOUNT_GROUP';

export class AccountGroupsRouterStates {
    /** @ngInject */
    constructor($stateProvider) {
        this.$stateProvider = $stateProvider;
    }

    defineStates() {

        this.$stateProvider.state(LISTROUTE, {
            url: '/accountGroups',
            templateUrl: './app/views/administration/accountGroups/overview.html',
            controller: 'CommonViewController',
            controllerAs: 'vm',
            params: {
                pageTitle: LISTTITLE
            }
        }).state(ADDROUTE, {
            url: '/addGroup',
            templateUrl: './app/views/administration/accountGroups/detail.html',
            controller: 'AddGroupController',
            controllerAs: 'groupController',
            params: {
                pageTitle: ADDTITLE,
                editMode: 'create',
                listView: LISTROUTE,
                createOrUpdateFunction: 'create'
            }
        }).state(DETAIL_GROUPROUTE, {
            url: '/group/{id}',
            templateUrl: './app/views/administration/accountGroups/detail.html',
            controller: 'GroupDetailController',
            controllerAs: 'groupController',
            params: {
                pageTitle: DETAIL_TITLE,
                editMode: 'view',
                listView: LISTROUTE,
                createOrUpdateFunction: null
            }
        }).state(EDITROUTE, {
            url: '/editGroup/{id}',
            templateUrl: './app/views/administration/accountGroups/detail.html',
            controller: 'GroupDetailController',
            controllerAs: 'groupController',
            params: {
                pageTitle: EDITTITLE,
                editMode: 'edit',
                listView: LISTROUTE,
                createOrUpdateFunction: 'update'
            }
        }).state(DELETEROUTE, {
            url: '/deleteGroup',
            templateUrl: './app/views/delete/confirmation.html',
            controller: 'DeleteConfirmationController',
            controllerAs: 'deleteConfirmationController',
            params: {
                names: null,
                ids: null,
                pKey: 'groupId',
                restUrl: groups,
                pageTitle: 'DELETE_ACCOUNT_GROUP',
                pageBody: 'CONFIRMATION_DELETE_ACCOUNT_GROUP'
            }
        });
    }
}
